import { useState } from "react";
import { Link } from "react-router-dom";
import { HelpCircle, X, Mail, MessageSquare } from "lucide-react";

const TERMS = [
  ["Domain", "Your website's address, like yourbusiness.com. You buy it once a year from a registrar."],
  ["Hosting", "The computer space where your website lives so people can visit it."],
  ["HTTPS / SSL", "The padlock in the browser — it keeps visitors' information safe."],
  ["Advance", "A part-payment to start your project. The rest is paid before your site goes live."],
  ["Recurring charge", "A fee that repeats every month or year, like maintenance."],
  ["Third-party cost", "Paid directly to another company (e.g. domain registrar, payment provider), not to Altiora."],
  ["Responsive", "Your website adjusts to phones, tablets and computers. Always included free."],
  ["Integration", "Connecting your website to another service, such as WhatsApp, payments or Google Maps."],
];

export default function HelpWidget() {
  const [open, setOpen] = useState(false);
  return (
    <div className="help-widget fixed bottom-5 right-5 z-50">
      {open && (
        <div className="mb-3 w-[min(92vw,360px)] max-h-[70vh] overflow-auto card-lux !p-5 shadow-2xl fade-up" data-testid="help-panel">
          <div className="flex items-center justify-between"><p className="font-display text-xl text-[#062a20]">Need a hand?</p><button onClick={() => setOpen(false)} aria-label="Close help" data-testid="help-close"><X className="w-4 h-4" /></button></div>
          <p className="text-xs text-slate-500 mt-1">Your progress is saved automatically — you can leave and come back any time.</p>
          <p className="eyebrow mt-4">Simple explanations</p>
          <dl className="mt-2 space-y-2 text-sm">{TERMS.map(([t, d]) => <div key={t}><dt className="font-semibold text-[#062a20]">{t}</dt><dd className="text-slate-600 text-xs">{d}</dd></div>)}</dl>
          <p className="eyebrow mt-4">Talk to a person</p>
          <div className="mt-2 flex flex-col gap-2 text-sm">
            <a href="mailto:hello@altiora.ventures" className="inline-flex items-center gap-2 underline" data-testid="help-email"><Mail className="w-4 h-4" /> hello@altiora.ventures</a>
            <Link to="/contact?service=Website%20Development" className="inline-flex items-center gap-2 underline" data-testid="help-contact"><MessageSquare className="w-4 h-4" /> Send us a message</Link>
          </div>
        </div>)}
      <button onClick={() => setOpen(!open)} className="ml-auto flex items-center gap-2 rounded-full bg-[#0b3d2e] text-[#f6ecd2] px-4 py-3 shadow-lg hover:bg-[#0f4f3c] transition-colors" aria-expanded={open} data-testid="help-button">
        <HelpCircle className="w-5 h-5" /><span className="text-sm font-semibold hidden sm:inline">Help</span>
      </button>
    </div>
  );
}
